import { styled, SxProps, Tooltip, tooltipClasses } from "@mui/material";

import { shouldForwardPropHelper } from "utils/shouldForwardPropHelper";

import { useLocalTimeTooltip } from "./useLocalTimeTooltip";

import type { ReactElement } from "react";

const TOOLTIP_MAX_WIDTH = 260;

interface LocalTimeTooltipProps {
  children: ReactElement;
  date: Date;
  customTitle?: string;
  sx?: SxProps;
  underlineDisabled?: boolean;
  withSeconds?: boolean;
}

export function LocalTimeTooltip({
  date,
  children,
  sx,
  withSeconds = true,
  underlineDisabled = false,
  customTitle,
}: LocalTimeTooltipProps) {
  const { title } = useLocalTimeTooltip({ date, withSeconds });

  return (
    <UnderlinedTooltip
      children={children}
      placement="bottom"
      sx={sx}
      title={customTitle ?? title}
      underlineDisabled={underlineDisabled}
      PopperProps={{
        disablePortal: true,
      }}
      arrow
    />
  );
}

const PROPS_SET = new Set(["underlineDisabled"]);

interface UnderlinedTooltipProps {
  underlineDisabled: boolean;
}
const UnderlinedTooltip = styled(Tooltip, {
  shouldForwardProp: (prop) => shouldForwardPropHelper(prop, PROPS_SET),
})<UnderlinedTooltipProps>(({ underlineDisabled }) => ({
  cursor: "pointer",

  ...(!underlineDisabled && {
    backgroundImage:
      "linear-gradient(to right, rgba(105, 111, 140, 1) 40%, rgba(105,111,140,0) 0%)",
    backgroundPosition: "bottom",
    backgroundSize: "5px 1px",
    backgroundRepeat: "repeat-x",
  }),

  [`+ .${tooltipClasses.popper}`]: {
    maxWidth: TOOLTIP_MAX_WIDTH,
  },
}));
